<template>
	<div
		@click.stop="$emit('update:modelValue', !modelValue)"
		:class="[
			'grid place-items-center min-w-[30px] h-dj-30 cursor-pointer rounded-full',
			modelValue ? 'bg-dj-blue-light' : 'bg-blue-light  border border-dj-gray-light',
		]"
	>
		<BaseIcon
			class="text-[24px]"
			:icon="modelValue ? 'ic:outline-close' : 'ic:outline-expand-more'"
			:color="modelValue ? '#969BA5' : '#1E2328'"
		/>
	</div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "DropdownButton",
	props: {
		modelValue: {
			type: Boolean,
			default: false,
			required: true,
		},
	},
	emits: ["update:modelValue"],
});
</script>
